<template>
    <div>
        <button class="btn btn-outline-dark" @click="showClass = !showClass">Create Class</button>
        <br />
        <div class="mt-3" v-if="showClass">
            <div v-if="!showUsers">
                <v-text-field v-model.trim="name" label="Name"></v-text-field>
                <button
                    class="btn btn-sm btn-outline-info"
                    :disabled="!name"
                    @click="showUsers = true"
                >Add Students</button>
            </div>
            <div class="mt-5" v-else>
                <h5>Add {{type + 's' | capitalise }}</h5>
                <div style="display:flex">
                    <v-text-field
                        v-model.trim="email"
                        :error-messages="emailErr"
                        :label="`Enter ${type} email`"
                        @keydown.enter="if (checkComplete) { add(); }"
                    ></v-text-field>
                    <v-icon :disabled="!checkComplete" @click="add()">mdi-plus</v-icon>
                </div>
                <div>
                    Selected {{ type + 's' }}:
                    <span v-if="type == 'student'">
                        <span
                            v-for="(student, i) in students"
                            :key="student"
                            @click="students.splice(students.indexOf(student), 1)"
                            style="cursor:pointer"
                        >{{ i==students.length-1 ? `${student}` : `${student}, ` }}</span>
                    </span>
                    <span v-else>
                        <span
                            v-for="(teacher,i) in teachers"
                            :key="teacher"
                            @click="teachers.splice(teachers.indexOf(teacher), 1)"
                            style="cursor:pointer"
                        >{{ i==teachers.length-1 ? `${teacher}` : `${teacher}, ` }}</span>
                    </span>
                </div>
                <br />
                <button
                    class="btn btn-sm btn-outline-info"
                    :disabled="!students.length"
                    v-if="type=='student'"
                    @click="type='teacher'"
                >Add Teachers</button>
                <button
                    v-else
                    @click="submit()"
                    :disabled="!teachers.length"
                    class="btn btn-sm btn-outline-success"
                >Submit</button>
            </div>
        </div>
    </div>
</template>

<script>
const fb = require("../../firebaseConfig");
import { debounce } from "lodash";
const classCreate = fb.functions.httpsCallable("initClass");
export default {
    data() {
        return {
            showUsers: false,
            showClass: false,
            name: "",
            email: "",
            emailErr: "",
            students: [],
            teachers: [],
            checkComplete: false,
            type: "student"
        };
    },
    watch: {
        email: function(newVal, oldVal) {
            this.checkComplete = false;
            this.emailErr = "";
            if (!newVal) {
                return;
            }
            this.debouncedChange();
        }
    },
    created() {
        this.debouncedChange = debounce(this.change, 1000);
    },
    methods: {
        change() {
            if (!this.email) {
                return;
            }
            fb.db
                .collection("users")
                .where("type", "==", this.type)
                .where("email", "==", this.email.toLowerCase())
                .get()
                .then(qs => {
                    if (qs.empty) {
                        this.emailErr = `No ${this.type} found`;
                    } else {
                        this.checkComplete = true;
                    }
                });
        },
        add() {
            if (this.type == 'student') {
              this.students.includes(this.email.toLowerCase) ? null : this.students.push(this.email.toLowerCase());
            } else {
              this.teachers.includes(this.email.toLowerCase) ? null : this.teachers.push(this.email.toLowerCase());
            }
            this.email = ''
        },
        submit() {
          classCreate({
                name: this.name,
                students: this.students,
                teachers: this.teachers
            }).then(result => {
                console.log(result.data);
                this.$emit(
                    'toast',
                    "war",
                    "Process complete. Check logs in developer console."
                );
            });
          this.teachers = []
          this.students = []
          this.type = 'student'
          this.showUsers = false
          this.name = '';
          this.showClass = false;
        }
    },
    filters: {
      capitalise(v) {
        return v.charAt(0).toUpperCase() + v.slice(1);
      }
    }
};
</script>